export default __webpack_public_path__ + "static/media/calenderm.9d22b8b6.png";